export const OrganisationRegion = {
    AU: 'AU'
};
